import PropTypes from "prop-types";
import React, { useContext } from "react";

import { classNames } from "@swa-ui/string";

import "../../generated/platforms/scss/vacations-dark.module.scss";
import "../../generated/platforms/scss/vacations-light.module.scss";
import "../../generated/platforms/scss/vacations.module.scss";
import { DesignTokensThemeContext, DesignTokensThemeProvider } from "../DesignTokensThemeProvider";

/**
 * Theme for SWA Vacations light styles.
 */

export const VacationsTheme = (props) => {
  const { children } = props;
  const { isDarkMode } = useContext(DesignTokensThemeContext) ?? {};

  return <DesignTokensThemeProvider {...getProps()}>{children}</DesignTokensThemeProvider>;

  function getProps() {
    return {
      className: classNames(
        isDarkMode ? "vacations-dark-theme" : "vacations-light-theme",
        "vacations-theme"
      ),
      inverse: false,
      themeName: "vacations",
    };
  }
};

VacationsTheme.propTypes = {
  /** Content that will be rendered within the theme. */
  children: PropTypes.node,
};
